export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./balance-reports.vue?vue&type=template&id=43a82bb9&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/curacao/balance-reports.vue?vue&type=template&id=43a82bb9&scoped=true
// module id = NT9C
// module chunks = 0